(function ($) {
    window.pageConfig = {
        module: '',
        productId: ''
    };
    var common = {
        /*
        type: 是否当前页面打开
        isv: 是否添加访客参数
         */
        gotoLogin: function (type, isv) {
            var linksourcemodule = window.cateData.userRecordOption.module || document.title;
            var category1 = window.cateData.userRecordOption.category1 || '';
            var category2 = window.cateData.userRecordOption.category2 || '';
            var url = '';
            if (isv) {
                url = solution_host + '/account/login?v=v&backUrl=' + encodeURIComponent(window.location.href) + '&linksourcemodule=' + linksourcemodule + '&category1=' + category1 + '&category2=' + category2;
            } else {
                url = solution_host + '/account/login?backUrl=' + encodeURIComponent(window.location.href) + '&linksourcemodule=' + linksourcemodule + '&category1=' + category1 + '&category2=' + category2;
            }
            if (type === 'blank') {
                window.open(url);
            } else {
                window.location.href = url;
            }
        },

        // 去注册
        gotoReg: function(type) {
            var linksourcemodule = window.cateData.userRecordOption.module || document.title;
            var category1 = window.cateData.userRecordOption.category1 || '';
            var category2 = window.cateData.userRecordOption.category2 || '';
            var url = solution_host + '/account/register?backUrl=' + encodeURIComponent(window.location.href) + '&linksourcemodule=' + linksourcemodule + '&category1=' + category1 + '&category2=' + category2;
            if (type === 'blank') {
                window.open(url);
            } else {
                window.location.href = url;
            }
        },

        isLogin: function () {
            var memberCookie = this.getCookie('smarketMember_' + window.cateData.schemaId);
            if (memberCookie) {
                var returnObj =  $.parseJSON(memberCookie);
                returnObj['OCSESSID'] = common.getCookie('OCSESSID') || '';
                return returnObj;
            } else {
                gio('clearUserId');
                return false;
            }
        },

        // 检查是否登录，session是否有效
        checkLogin: function() {
            var _this = this;
            if (common.getCookie('OCSESSID') && common.isLogin()) {
                var ocsession = common.getCookie('OCSESSID');
                ocsession = ocsession.replace('\"', "");
                $.post('/index.php?route=api/login/check', {
                    ocSession: ocsession,
                    smarketSession: common.isLogin().session
                }, function (res) {
                    if (res.data && !res.data.status) {
                        _this.delCookie('smarketMember_498');
                        _this.delCookie('OCSESSID');
                    }
                });
            }
        },

        // 退出登录
        loginOut: function (isv) {
            this.delCookie('smarketMember_498');
            this.delCookie('OCSESSID');
            gio('clearUserId');
            userAction.logOut();
            this.postJson(solution_host + '/api/account/logout');
            this.gotoLogin('', isv);
        },

        //获取cookie
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg)) {
                return decodeURIComponent(arr[2]);
            } else {
                return null;
            }
        },

        //写cookie
        setCookie: function (name, value, days) {
            var Days = days || 30;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

            // 判断url中是否包含了 eshop
            if (window.location.href.indexOf('local-eshop') > -1) {
                document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ';domain=.dellemc-solution.com;path=/';
            }else{
                document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ';domain=.dellemc-solution.com;path=/;SameSite=None;secure';
            }
        },

        //删除cookie
        delCookie: function (key) {
            this.setCookie(key, '');
        },

        //写入SessionStorage
        setSS: function(name, value, isJson){
            if(isJson){
                sessionStorage.setItem(name, JSON.stringify(value));
            }else{
                sessionStorage.setItem(name, value);
            }
        },

        getSS: function(name, isJson){
            if(isJson){
                return JSON.parse(sessionStorage.getItem(name));
            }else{
                return sessionStorage.getItem(name);
            }
        },

        //获取地址栏参数
        getUrlPara: function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r !== null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },

        getHashParameters: function () {
            if(!location.hash){
                return null;
            }
            var arr = (location.hash || '').split('#')[1].split('&');
            var params = {}
            for (var i = 0; i < arr.length; i++) {
                var data = arr[i].split('=');
                if (data.length === 2) {
                    params[data[0]] = data[1]
                }
            }
            return params;
        },
        // 获取Hash参数
        getHashPara: function (key) {
            var params = this.getHashParameters();
            return params?decodeURIComponent(params[key]):null;
        },

        changeUrlParams(par, search, value) {
            var pattern = par + '=([^&]*)';
            var replaceText = par + '=' + value;
            if (search.match(pattern)) {
                var tmp = '/\\' + par + '=[^&]*/';
                tmp = search.replace(eval(tmp), replaceText);
                return tmp;
            }
            return '';
        },

        // 阻止冒泡
        stopBubble: function (event) {
            //取消事件冒泡
            var e = arguments.callee.caller.arguments[0] || event; //若省略此句，下面的e改为event，IE运行可以，但是其他浏览器就不兼容
            if (e && e.stopPropagation) {
                // this code is for Mozilla and Opera
                e.stopPropagation();
            } else if (window.event) {
                // this code is for IE
                window.event.cancelBubble = true;
            }
        },

        // 返回去除空格的字符串
        getGIOValue: function(class_name){
            return $.trim($('.'+ class_name).text() || $('.'+ class_name).val() );
        },

        //时间戳转日期
        handleTime: function (time) {
            if (!time) {
                return '';
            }
            var date = new Date(time * 1000);

            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            // var D = date.getDate() + ' ';
            var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
            /*var h = date.getHours() + ':';
            var m = date.getMinutes() + ':';
            var s = date.getSeconds();*/

            return Y + M + D;
        },

        //时间戳转日期
        handleTimeObj: function (time) {
            if (!time) {
                return '';
            }
            var date = new Date(time * 1000);

            return {
                Y: date.getFullYear(),
                M: (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1),
                D: (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
                h: date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
                m: date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
                s: date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            }
        },

        // 获取当前日期 20221008
        getNowDate: function() {
            var data = new Date();
            var time = data.getTime();
            var timeObj =  this.handleTimeObj(time/1000);
            return String(timeObj.Y) + timeObj.M + timeObj.D;
        },

        // 获取短信发送签名
        getSendCodeSign: function () {
            return md5(this.getNowDate() + '_dell').substr(10,20)
        },

        browseArticle: function (id) {
            api.browseArticle(id)
        },

        //阻止默认事件
        stopDefaultAction: function (e) {
            e.preventDefault();
        },

        isM: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        isWx: !!navigator.userAgent.match(/MicroMessenger.+?([\d.]+)/i) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        isIE: !!window.ActiveXObject || "ActiveXObject" in window,

        // 获取搜索来源类型
        getSearchSourceType(){
            var searchSource = '';
            var ishotTypeNum = common.getUrlPara('ishot');
            switch (ishotTypeNum) {
                case '1':
                    searchSource = '热门搜索';
                    break;
                case '2':
                    searchSource = '热搜推荐';
                    break;
                case '3':
                    searchSource = '热搜词陈列';
                    break;
                case '4':
                    searchSource = '预置热搜词';
                    break;
                case '5':
                    searchSource = '关联搜索';
                    break;
                default:
                    searchSource = '手动搜索';
            }

            return searchSource
        },

        getGlobalUserId:function(){
            var cookieGlobalUserId = this.getCookie('globalUserId');
            if(cookieGlobalUserId){
                cookieGlobalUserId = cookieGlobalUserId.replace(/"/g, ""); //去除双引号
                return cookieGlobalUserId;
            }

            var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function(c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
            uuid = uuid.replace(/-/g, "");
            this.setCookie('globalUserId',uuid);
            return uuid;
        },

        /**
         * 判断是否为小程序的webView
         * @returns {boolean}
         */
        isFromXCX: function () {
            return common.getCookie('fromXCX') === 'true';
        },

        isFromXCXDef: function (callback) {
            //判断callback是否为函数
            if(typeof callback !== 'function'){
                return;
            }

            if(!common.getCookie('fromXCX')){
                callback(false);
            }

            if(common.isXCX()){
                callback(true);
            }else{
                common.setCookie('fromXCX', false);
                callback(false);
            }

        },


        isXCX: function () {
            // 微信7.0之后的版本，小程序环境下，navigator.userAgent中会包含miniProgram字段
            return navigator.userAgent.indexOf('miniProgram') > -1
        },

        postJson: function (url, info, callback, cross, type) {
            $.ajax({
                type: type || "POST",
                url: url,
                data: JSON.stringify(info),
                dataType: "json",
                contentType: 'text/plain',
                crossDomain: cross || false,
                xhrFields: {
                    withCredentials: cross || false
                },
                success: function (data) {
                    if(typeof callback === 'function'){
                        callback(data);
                    }
                },
                error: function (data) {
                    if (window.isDebug) {
                        console.log(data);
                    }
                }
            });
        },

        getJson: function (url, info, callback, cross) {
            $.ajax({
                type: "GET",
                url: url,
                data: info,
                dataType: "json",
                contentType: 'text/plain',
                crossDomain: cross || false,
                xhrFields: {
                    withCredentials: cross || false
                },
                success: function (data) {
                    callback(data);
                },
                error: function (data) {
                    if (window.isDebug) {
                        console.log(data);
                    }
                }
            });
        },

        // 继承
        //继承方法
        extend:function (destination, source) {
            if (!source) {
                return destination;
            }
            for (var property in source) {
                destination[property] = source[property];
            }
            return destination;
        },

        //弹窗后禁止后方页面滚动
        setScroll : {
            scrollTop: 0,
            isDisScroll: false,

            unScroll: function () {
                if (!this.isDisScroll) {
                    this.scrollTop = $(window).scrollTop();
                    document.body.classList.add('article-scroll-fixed');
                    document.body.style.top = -this.scrollTop + 'px';
                    this.isDisScroll = true;
                }
            },

            removeUnScroll: function() {
                document.body.classList.remove('article-scroll-fixed');
                document.body.style.top = '';
                $(window).scrollTop(this.scrollTop);
                this.isDisScroll = false;
            },
        },

        gotoUrl: function (url) {
            window.open(url);
        },
        gotoUrlSelf: function (url) {
            if(!url){
                return;
            }
            window.location.href = url;
        },

        //手机号脱敏
        mobileEncryption:function(mobile) {
            if(!mobile){
                return false;
            }
            return mobile.substr(0,4) + '***' + mobile.substr(7,4);
        },

        // 判断上划下滑 显示隐藏副导航
        setupScrollBehavior: function (subNavSelector) {
            var lastScrollPosition = 0;
            // 监听滚动事件
            window.addEventListener('scroll', () => {
                // 获取导航栏元素
                var header = document.querySelector(subNavSelector);
                if(!header) return;
                const currentScrollPosition = window.scrollY;

                // 窗口高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                // 页面高度
                var documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                // 滚动条位置
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

                if (currentScrollPosition > lastScrollPosition) {
                    // 下滑时隐藏导航
                    header.style.display = 'none';
                } else {
                    // 上划时显示导航
                    header.style.display = 'block';
                }

                // 到达顶部或底部时显示导航
                if (scrollTop <= 0 || (windowHeight + scrollTop + 2) >= documentHeight) {
                    header.style.display = 'block';
                }

                lastScrollPosition = currentScrollPosition;
            });
        },
};

    common.checkLogin();


    //通用接口
    var api = {
        //获取短链接的code
        getShortUrlCode: function (url) {
            return request({
                url: 'api/common/shorturl/create',
                method: 'post',
                params: {url: url}
            });
        },

        // 浏览文章、增加阅读量
        browseArticle: function (id) {
            // 浏览
            $.ajax({
                type: "GET",
                url: window.solution_host + '/api/detail/browse/' + id,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                }
            });
        }

    };

    var fieldHandle = {
        //获取表单字段值
        //attrValue 属性 data-value 的名字
        //changeFunc 界面输入改变后回调此函数
        HandelValue: function (attrValue, attrVerValue, attrVerElValue, inputErrorClass, emptyText, errorText, vFunc, callback) {
            this.el = document.querySelector('*[data-value="' + attrValue + '"]');
            this.errorEl = document.querySelector('*[data-value="' + attrVerValue + '"]');
            this.errorBoxEl = document.querySelector('*[data-value="' + attrVerElValue + '"]');
            this.value = '';
            this.isVerif = true;
            this.set = function (newValue) {
                this.el.value = newValue;
                this.value = newValue;
            };
            this.get = function () {
                return this.value;
            };
            var _this = this;
            this.change = function () {
                _this.value = _this.el.value;
                if(!_this.value){
                    isErrr(emptyText);
                }else if(typeof(vFunc) === 'function' && !vFunc(_this.value)){
                    isErrr(errorText);
                }else{
                    isRight();
                }
                if( typeof(callback) === 'function'){
                    callback(_this.isVerif);
                }
            };
            //初始化
            this.init = function(){
                isRight();
            };
            this.init();

            function isErrr(text) {
                _this.errorEl.textContent = text;
                _this.isVerif = false;
                _this.errorBoxEl.style.display="";
                _this.el.classList.add(inputErrorClass);
            }

            function isRight() {
                _this.errorEl.textContent = '';
                _this.isVerif = true;
                _this.errorBoxEl.style.display="none";
                _this.el.classList.remove(inputErrorClass);
            }
            this.el.addEventListener('keyup', this.change);

        },

        //处理表单radio字段
        HandelRadio: function (name) {
            this.radioName  = name;
            this.radios = document.getElementsByName(this.radioName);
            this.value = 0;
            this.resultValueArr = []; //samrket表单提交要求radio的值是个数组

            //设置
            this.set = function (value) {
                this.value = value;
                for(var i=0;i<this.radios.length;i++){
                    if(this.radios[i].value === this.value){
                        this.radios[i].checked = true;
                    }
                }
            };

            //获取
            this.get = function () {
                for(var i=0;i<this.radios.length;i++){
                    if(this.radios[i].checked === true){
                        this.value = this.radios[i].value;
                    }
                }
                this.resultValueArr.push(this.value)
                return this.resultValueArr;
            };
        },

        //处理表单radio字段带验证
        // name: radio的 name
        // attrVerElValue: 错误信息容器的  data-value
        HandelRadioVerif: function(name, attrVerElValue) {
            this.radioName  = name;
            this.radios = document.getElementsByName(this.radioName);
            this.value = 0;
            this.resultValueArr = []; //samrket表单提交要求radio的值是个数组
            this.isVerif = true;
            this.errorBoxEl = document.querySelector('*[data-value="' + attrVerElValue + '"]');

            //设置
            this.set = function (value) {
                this.value = value;
                for(var i=0;i<this.radios.length;i++){
                    if(this.radios[i].value === this.value){
                        this.radios[i].checked = true;
                    }
                }
            };

            // 设置为空
            this.setNull = function () {
                for(var i=0;i<this.radios.length;i++){
                    this.radios[i].checked = false;
                }
            };

            //获取
            this.get = function () {
                for(var i=0;i<this.radios.length;i++){
                    if(this.radios[i].checked === true){
                        this.value = this.radios[i].value;
                    }
                }
                this.resultValueArr.push(this.value);
                return this.resultValueArr;
            };

            // 验证
            var _this = this;
            this.change = function () {
                _this.value = false;
                for(var i=0;i<_this.radios.length;i++){
                    if(_this.radios[i].checked){
                        _this.value = _this.radios[i].value;
                    }
                }
                if(!_this.value){
                    isErrr();
                }else{
                    isRight();
                }
            };
            function isErrr() {
                _this.isVerif = false;
                _this.errorBoxEl.style.display="";
            }

            function isRight() {
                _this.isVerif = true;
                _this.errorBoxEl.style.display="none";
            }

            for(var i=0;i<_this.radios.length;i++){
                _this.radios[i].addEventListener('click',function () {
                    _this.change();
                });
            }
            //初始化
            this.init = function(){
                console.log(111);
                isRight();
            };
            this.init();
        }

}


    var baseVerif = {
        isMobile: function (str) {
            if (str === null || str === "") {
                return false;
            }
            var result = str.match(/^((\(\d{2,3}\))|(\d{3}\-))?(1\d{10})$/);
            if (result === null) {
                return false;
            }
            return true;
        },
        //检查EMAIL
        isEmail: function (str) {
            // var reg = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
            var reg = /^\S+@\S+$/;
            var flag = reg.test(str);
            return flag;
        },

        //座机
        isPhone: function (str) {
            var reg = /^[0-9-()（）#]{2,18}$/;
            var flag = reg.test(str);
            return flag;
        },

        isPassword: function (str) {
            // var reg = /^[A-Za-z0-9]{6,20}$/;
            // var flag = reg.test(str);
            // return flag;
            return str && str.length >= 6 && str.length <= 20;
        }
    }

    function postJson(url, info, callback, cross, type) {
        $.ajax({
            type: type || "POST",
            url: url,
            data: JSON.stringify(info),
            dataType: "json",
            contentType: 'text/plain',
            crossDomain: cross || false,
            xhrFields: {
                withCredentials: cross || false
            },
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                if (window.isDebug) {
                    console.log(data);
                }
            }
        });
    }

    function getJson (url, info, callback, cross) {
        $.ajax({
            type: "GET",
            url: url,
            data: info,
            dataType: "json",
            contentType: 'text/plain',
            crossDomain: cross || false,
            xhrFields: {
                withCredentials: cross || false
            },
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                if (window.isDebug) {
                    console.log(data);
                }
            }
        });
    }

    //继承方法
    window.baseExtend = function(destination, source) {
        if (!source) {
            return destination;
        }
        for (var property in source) {
            destination[property] = source[property];
        }
        return destination;
    }

    //商品数量的加减
    //cutClass ：
    window.ProductNumCtr = function(cutClass, numClass, addClass, numLimit) {
        var cutEl = document.querySelector(cutClass);
        var numEl = document.querySelector(numClass);
        var addEl = document.querySelector(addClass);

        if(!cutEl || !numEl || !addEl){
            return;
        }

        var _this = this;

        this.num = 1;

        this.cut = function () {
            if(_this.num > 1) {
                _this.num -= 1;
            }
            _this.setNum();
        };

        this.add = function () {
            if(numLimit){
                if(_this.num >= numLimit){
                    return;
                }
            }
            _this.num += 1;
            _this.setNum();
        };

        this.setNum = function (num) {
            if(!num){
                numEl.textContent = _this.num;
            }else{
                if(numLimit && num >= numLimit){
                    num = numLimit;
                }
                _this.num = num;
                numEl.textContent = _this.num;
            }
        };

        this.getNum = function () {
            return _this.num;
        };

        this.destroy = function () {
            cutEl.removeEventListener('click',  _this.cut);
            addEl.removeEventListener('click', _this.add);
            numLimit = null;
        };


        cutEl.addEventListener('click',  _this.cut);
        addEl.addEventListener('click', _this.add);

        return {
            getNum: this.getNum,
            setNum: this.setNum,
            cut: this.cut,
            add: this.add,
            destroy: this.destroy
        };

    }



    window.common = common;
    window.fieldHandle = fieldHandle;
    window.baseVerif = baseVerif;
    window.postJson = postJson;
    window.getJson = getJson;
})(jQuery);
